import debug from 'debug'

function pretty (namespace, level, message) {
  const logger = debug(`app:${namespace}`)
  const msg = `${level} ${message}`
  logger(msg)
}

export default pretty
